import { useEffect, useState } from 'react';

import { Loader } from '@googlemaps/js-api-loader';
import { CONFIG } from '@frontend/config';

let mapsPromise: Promise<google.maps.MapsLibrary> | null = null;
let placesPromise: Promise<google.maps.PlacesLibrary> | null = null;

// A different key is only supported in a separate window (the SDK is global).
export const useGoogleMapsApiLoader = ({ includePlaces = true, apiKey = CONFIG.GOOGLE_KEY } = {}) => {
  const [state, setState] = useState({
    isLoaded: false,
    loadError: false,
    maps: null as google.maps.MapsLibrary | null,
    places: null as google.maps.PlacesLibrary | null,
  });

  useEffect(() => {
    let active = true;
    setState({ isLoaded: false, loadError: false, maps: null, places: null });
    async function load() {
      try {
        if (!apiKey?.trim()) throw new Error('Map configuration unavailable');
        const loader = new Loader({ id: 'google-map-script', version: 'weekly', apiKey });
        mapsPromise ??= loader.importLibrary('maps').catch((error) => {
          mapsPromise = null;
          throw error;
        });
        if (includePlaces) {
          placesPromise ??= loader.importLibrary('places').catch((error) => {
            placesPromise = null;
            throw error;
          });
        }
        const [maps, places] = await Promise.all([mapsPromise, includePlaces ? placesPromise : null]);
        if (active) setState({ isLoaded: true, loadError: false, maps, places });
      } catch {
        // SDK errors can contain credential-bearing URLs; expose only a safe state.
        if (active) setState({ isLoaded: false, loadError: true, maps: null, places: null });
      }
    }
    void load();
    return () => {
      active = false;
    };
  }, [includePlaces, apiKey]);

  return state;
};
